import * as React from "react";
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";

const Task = () => {
  return (
    <Grid container>
      <Outlet></Outlet>
    </Grid>
  );
};

export default Task;
